import { graphql } from 'relay-runtime';

export const createClass = graphql`
  mutation ClassesCreateClassMutation($input: CreateClassInput!) {
    createClass(input: $input) {
      classNode {
        id
        name
        section
        gradeLevels {
          name
          id
        }
        site {
          id
          name
        }
        isActive
        users {
          id
          firstName
          lastName
          isActive
          roles {
            name
          }
          sites {
            id
            name
          }
          classes {
            name
          }
          gradeLevels {
            name
            id
          }
        }
        owner {
          id
          firstName
          lastName
        }
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`;

export const updateClass = graphql`
  mutation ClassesUpdateClassMutation($input: UpdateClassInput!) {
    updateClass(input: $input) {
      classNode {
        id
        name
        section
        gradeLevels {
          name
          id
        }
        site {
          id
          name
        }
        isActive
        users {
          id
          firstName
          lastName
          isActive
          roles {
            name
          }
          sites {
            id
            name
          }
          classes {
            name
          }
          gradeLevels {
            name
            id
          }
        }
        owner {
          id
          firstName
          lastName
        }
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`;

export const allClasses = graphql`
  query ClassesGetAllQuery($filter: ClassesFilterInput, $cursor: String, $skip: Boolean = false) {
    classes(classesFilterInput: $filter, first: 100, after: $cursor) @skip(if: $skip) {
      nodes {
        id
        name
        section
        site {
          id
          name
        }
        gradeLevels {
          name
          id
        }
        isActive
        users {
          id
          firstName
          lastName
          publicUserId
          isActive
          roles {
            name
          }
          sites {
            id
            name
          }
          classes {
            name
          }
          gradeLevels {
            name
            id
          }
        }
        owner {
          id
          firstName
          lastName
        }
        externalSync {
          source
        }
      }
      pageInfo {
        endCursor
      }
    }
  }
`;

export const allClassesBasicData = graphql`
  query ClassesGetAllBasicDataQuery(
    $filter: ClassesFilterInput
    $cursor: String
    $skip: Boolean = false
    $first: Int = 100
  ) {
    classes(first: $first, after: $cursor, classesFilterInput: $filter) @skip(if: $skip) {
      nodes {
        id
        name
        section
        site {
          id
          name
        }
        gradeLevels {
          name
          id
        }
        isActive
        owner {
          id
          firstName
          lastName
        }
        externalSync {
          source
        }
      }
      pageInfo {
        endCursor
      }
    }
  }
`;

export const classesByTeacherId = graphql`
  query ClassesGetByTeacherIdQuery($filter: ClassesFilterInput, $teacherId: ID!, $skip: Boolean = false) {
    classesByTeacherId(classesFilterInput: $filter, teacherId: $teacherId) @skip(if: $skip) {
      id
      name
      section
      site {
        id
        name
      }
      gradeLevels {
        name
        id
      }
      isActive
      users {
        id
        firstName
        lastName
        publicUserId
        isActive
        userClasses {
          isActive
          class {
            id
            name
          }
        }
        roles {
          name
        }
        sites {
          id
          name
        }
        classes {
          name
        }
        gradeLevels {
          name
          id
        }
      }
      owner {
        id
        firstName
        lastName
      }
      externalSync {
        source
      }
    }
  }
`;

export const classesByTeacherIdOnlyClasses = graphql`
  query ClassesGetByTeacherIdOnlyClassesQuery($filter: ClassesFilterInput, $teacherId: ID!, $skip: Boolean = false) {
    classesByTeacherId(classesFilterInput: $filter, teacherId: $teacherId) @skip(if: $skip) {
      id
      name
      section
      site {
        id
        name
      }
      gradeLevels {
        name
        id
      }
      isActive
      owner {
        id
        firstName
        lastName
      }
      students {
        id
        publicUserId
      }
    }
  }
`;

export const allSites = graphql`
  query ClassesAllSitesQuery($input: SitesFilterInput) {
    sites(sitesFilterInput: $input, first: 100) {
      nodes {
        id
        name
        targetGroups {
          id
          name
        }
      }
    }
  }
`;

export const allGrades = graphql`
  query ClassesAllGradesQuery {
    allGradeLevels {
      id
      name
      isActive
      order
    }
  }
`;

export const getUsersByRole = graphql`
  query ClassesGetUsersByRoleQuery($roleId: ID!) {
    role(roleId: $roleId) {
      id
      users {
        id
        firstName
        lastName
        isActive
        roles {
          name
        }
        sites {
          id
          name
        }
        classes {
          name
          id
        }
        userClasses {
          isActive
          class {
            id
            name
          }
        }
        gradeLevels {
          name
          id
        }
      }
    }
  }
`;

export const addUsersToClass = graphql`
  mutation ClassesAddUsersToClassMutation($input: AddUsersToClassInput!) {
    addUsersToClass(input: $input) {
      userClassNode {
        user {
          id
          firstName
          lastName
          isActive
          userClasses {
            isActive
            class {
              id
              name
            }
          }
          roles {
            name
          }
          sites {
            id
            name
          }
          classes {
            name
          }
          gradeLevels {
            name
            id
          }
        }
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`;

export const removeUsersFromClass = graphql`
  mutation ClassesRemoveUsersFromClassMutation($input: RemoveUsersFromClassInput!) {
    removeUsersFromClass(input: $input) {
      userClassNode {
        user {
          id
          firstName
          lastName
          publicUserId
          isActive
          roles {
            name
          }
          sites {
            id
            name
          }
          classes {
            name
          }
          gradeLevels {
            name
            id
          }
        }
      }
    }
  }
`;

export const filtersDataQuickData = graphql`
  query ClassesQuickDataFiltersQuery($teacherId: ID!) {
    sites {
      nodes {
        id
        name
        isActive
      }
    }
    allGradeLevels {
      id
      name
      isActive
    }
    classesByTeacherId(teacherId: $teacherId) {
      id
      name
    }
  }
`;

export const getClassesForAssignmentDropdown = graphql`
  query ClassesAssignmentDropdownQuery {
    classes(first: 1000) {
      nodes {
        id
        name
        section
        site {
          id
        }
        owner {
          lastName
        }
      }
    }
  }
`;

export const globalClassFilterClasses = graphql`
  query ClassesGlobalFilterQuery($skip: Boolean = false) {
    classes(first: 1000, classesFilterInput: { isActive: ACTIVE, siteIsActive: ACTIVE }) @skip(if: $skip) {
      nodes {
        id
        name
        section
        students {
          id
        }
      }
    }
  }
`;

export const isStudentInManyClasses = graphql`
  query ClassesStudentWithManyClassesQuery($userId: ID!, $skip: Boolean = false) {
    isUserInMoreThanOneClass(userId: $userId) @skip(if: $skip)
  }
`;
